import gql from "graphql-tag"

const UPDATE_NEWS_SOURCE = gql`
  mutation updateNewsSource(
    $id: ID!
    $newsSourceUpdateInput: NewsSourceUpdateInput!
  ) {
    updateNewsSource(
      serviceName: $serviceName
      newsSourceUpdateInput: $newsSourceUpdateInput
    ) {
      id
      labelId
      outletId
      releaseDate
      serviceName
    }
  }
`

export default UPDATE_NEWS_SOURCE
